import React from 'react';
import Copyright from './Copyright';
import Footer from './Footer';

const Complete_Footer = () => {
    return (
        <React.Fragment>
            <Footer />
            <Copyright />
        </React.Fragment>
    )
}
export default Complete_Footer